import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Button } from "../../ui/button";
import { cn } from "../../lib/utils";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import NoDataFound from "../Common/table/NoDataFound";
import { AFFILIATE_CONSTANTS } from "../../sharedfiles/Constants";
import {
  getDateTimeFormate,
  getFromLocalStorage,
  formatMoney,
  cleanObject,
  MomentUTCDateTimeEnd,
  MomentUTCDateTimeToday,
  getConvertedAmountWithCurrency,
} from "../../sharedfiles/helper";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import Vpagination from "../../sharedfiles/Vpagination";
import {
  AddChannel,
  listChannels,
  setChanelVisible,
  setChannelItems,
  setChannelRecords,
  setChannel_page,
  setDocsData_channel,
  setChannelField,
  setChannelPayload,
  setDateValue,
} from "../Affiliate/AffiliateSlice";
import Input from "../Common/inputs/Input";
import { channelInfo } from "../../sharedfiles/tooltipMsgs";
import { chanelDates } from "../Common/data/mapData";

import Tooltips from "../Common/Tooltip";
import { DatePicker as Datepicker } from "../../ui/date-picker";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "../Common/table/TableToolbar";
function Channel(props) {
  const dispatch = useDispatch();
  const channelList = useSelector((st) => st.affiliateSlice.channelList?.data);
  // const platformId = useSelector(st => st.affiliateSlice.selected_AffiliateId);
  const { dateValue, isAffChannel } = useSelector(st => st.affiliateSlice);
  const viewOnlyuser = useSelector((state) => state.dashboard.viewOnlyuser)
  // Restores the Channel Name field and date filters after switching tabs
  // away and back (this page fully unmounts/remounts on tab switch) - read
  // once here and used only as lazy useState initializers below, so the very
  // first render already matches.
  const [channel, setChannel] = useState(() => props.channelField?.value ?? "");
  const [channelErr, setChannelErr] = useState(() => props.channelField?.error ?? false);
  const [tableData, setTableData] = useState([]);
  const [pdfBody, setPdfBody] = useState([]);
  const [dateFilters, setDateFilters] = useState(() => ({
    startDate: dateValue?.startDate ?? "",
    endDate: dateValue?.endDate ?? ""
  }));
  const [dateErr, setDateErr] = useState("")
  const [dateToErr, setDateToErr] = useState("")
  const [hasSearched, setHasSearched] = useState(false)

  // const channelId = localStorage.getItem("subAffUserId")
  // const userId = channelId || platformId
  // const userId = platformId || getFromLocalStorage("AffliateUserId");
  // const userId = getFromLocalStorage("AffliateUserId") || localStorage.getItem("subAffUserId")
  const userId = isAffChannel ? localStorage.getItem("subAffUserId") : getFromLocalStorage("AffliateUserId")
  const headers = [
    "Id",
    "Channel Name",
    "AffiliateId",
    "Created Date",
    "Updated Date",
    "Total Registrations",
    "Deposited Customers",
    "Total Deposits",
    "New Customers",
    "Total Stakes",
    "Total Payout",
    "GGR",
    "Total Bonus Amount",
    "Total Number of Bets",
    "Total Withdrawals",
    "URL Hits Count",
  ];
  const filedsHandler = (e) => {
    const { name, value } = e.target;
    const channelErr = value === ""
    setChannel(value);
    setChannelErr(channelErr);
    dispatch(setChannelField({ value: value, error: channelErr }))
  };
  const submit = (e) => {
    e.preventDefault();
    const payload = {
      userId: userId,
      body: { channelName: channel },
    };
    const isValid = channel === "" ? true : false;
    setChannelErr(isValid);
    dispatch(setChannelField({ value: channel, error: isValid }))
    if (!isValid && userId) {
      dispatch(AddChannel(payload));

      setTimeout(() => {
        callApi(1, 25, userId);
        setChannel("");
        dispatch(setChannelField({ value: "", error: false }));
      }, 500);
    }
  };
  const exportPDF = () => {
    const title = "Channel Report";
    exportPDFC(title, [headers], pdfBody);
  };

  const callApi = (page, items, userId) => {
    let payload = {
      userId: +userId,
      startDate: dateValue.startDate !== "" ? MomentUTCDateTimeToday(dateValue.startDate) : "",
      endDate: dateValue.endDate !== "" ? MomentUTCDateTimeEnd(dateValue.endDate) : ""
    }
    const filterdData = cleanObject(payload)
    dispatch(setChannelPayload(payload))
    dispatch(listChannels(page - 1, items, filterdData));
  };
  useEffect(() => {
    const dataExist = Object.keys(props?.channelList).length > 0 && props.channelList?.data?.length > 0
    if (!dataExist) {
      callApi(1, 25, userId);
    }
    else {
      const csvDataExist = props?.docsData_channel && Array.isArray(props.docsData_channel) && props.docsData_channel.length > 0
      let pdfData = [];
      if (csvDataExist) {
        pdfData = props?.docsData_channel.slice(1, props?.docsData_channel?.length);
      }
      setTableData(props.docsData_channel);
      setPdfBody(pdfData);
    }
  }, []);

  const updateTableData = () => {
    let tbData = [];
    if (Array.isArray(channelList) && channelList.length > 0) {
      const data = channelList.map((item) => [
        item.id,
        item.name,
        item.affiliateId,
        item.createdDate ? getDateTimeFormate(item.createdDate) : "-",
        item.updatedDate ? getDateTimeFormate(item.updatedDate) : "-",
        item.totalRegistration,
        item.depositedCustomers,
        getConvertedAmountWithCurrency(item.totalDeposit, item.currencyCode || item.currency, item.baseCurrencyRate),
        item.newCustomers,
        getConvertedAmountWithCurrency(item.totalStake, item.currencyCode || item.currency, item.baseCurrencyRate),
        getConvertedAmountWithCurrency(item.totalPayout, item.currencyCode || item.currency, item.baseCurrencyRate),
        getConvertedAmountWithCurrency(item.totalGgr, item.currencyCode || item.currency, item.baseCurrencyRate),
        item.totalBonus ? item.totalBonus : "0",
        item.betCount,
        getConvertedAmountWithCurrency(item.totalWithdraw, item.currencyCode || item.currency, item.baseCurrencyRate),
        item.channelClickCount,
      ]);
      tbData = [headers, channelInfo, ...data];
      setPdfBody(data);
    }
    else {
      tbData = [headers, channelInfo, []];
      setPdfBody([]);
    }
    setTableData(tbData);
    dispatch(setDocsData_channel(tbData))
  };
  useEffect(() => {
    channelList && updateTableData();
  }, [channelList]);
  const dateHandler = (value, name) => {
    setDateFilters((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
    if (name === "startDate" && value !== '') {
      setDateErr('')
    }
    const dummyObj = { ...dateFilters, [name]: value };
    dispatch(setDateValue(dummyObj))

  }
  function onSearchClick() {
    if (dateFilters.startDate === '' || dateFilters.startDate === null) {
      setDateErr("Start Date is required");
    } else if (dateFilters.startDate !== '') {
      setDateErr('');
      callApi(1, 25, userId)
    }

  }
  const channelRowAccessors = [
    (item) => item.id,
    (item) => item.name,
    (item) => item.affiliateId,
    (item) => (item.createdDate ? getDateTimeFormate(item.createdDate) : "—"),
    (item) => (item.updatedDate ? getDateTimeFormate(item.updatedDate) : "—"),
    (item) => item.totalRegistration ?? "0",
    (item) => item.depositedCustomers ?? "0",
    (item) => getConvertedAmountWithCurrency(item.totalDeposit, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => item.newCustomers ?? "0",
    (item) => getConvertedAmountWithCurrency(item.totalStake, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => getConvertedAmountWithCurrency(item.totalPayout, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => getConvertedAmountWithCurrency(item.totalGgr, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => item.totalBonus ?? "0",
    (item) => item.betCount ?? "0",
    (item) => getConvertedAmountWithCurrency(item.totalWithdraw, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => item.channelClickCount ?? "0",
  ];
  const { visibleIndices: channelVisibleIndices, allColumns: channelAllColumns, toggleVisibility: channelToggleVisibility, reorder: channelReorder, resetToDefault: channelResetToDefault } =
    useColumnPreferences("channelsChannel", headers);

  function onResetClick() {
    let payload = {
      userId: +userId,
      startDate: "",
      endDate: ""
    }
    const cleanPayload = cleanObject(payload);
    dispatch(setDateValue({
      startDate: "",
      endDate: "",
    }))
    setDateFilters({
      startDate: "",
      endDate: "",
    })
    setDateErr('');
    dispatch(setChannel_page(1))
    dispatch(setChannelItems(25))
    dispatch(setChannelRecords([1, 25]))
    dispatch(listChannels(0, 25, cleanPayload));
    dispatch(setChanelVisible(false))

  }

  return (
    <div className='space-y-6'>

      {/* Add Channel Section */}
      <div className='rounded-lg border bg-card shadow-sm'>
        <div className='bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-700 px-6 py-4 border-b'>
          <h2 className='text-xl font-semibold text-gray-800 dark:text-gray-100'>Add New Channel</h2>
          <p className='text-sm text-gray-600 dark:text-gray-400 mt-1'>Create a new marketing channel for tracking affiliate performance</p>
        </div>
        <div className='p-6'>
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4'>
            <Input
              title={"Channel Name"}
              name={"channel"}
              ids={"channel"}
              value={channel}
              placeholder={"Enter channel name"}
              setValue={(e) => filedsHandler(e)}
              errorMsg={channelErr && "Channel Name is required"}
              info={"Provide Channel Name"}
              show={true}
            />
          </div>
        </div>
        <div className='border-t bg-muted px-6 py-4 flex justify-center'>
          <Button
            onClick={(e) => submit(e)}
            type={"button"}
            id={"addChannel"}
            variant="default"
            disabled={viewOnlyuser}
          >
            {AFFILIATE_CONSTANTS.addChannel}
          </Button>
        </div>
      </div>

      {/* Filter Channels & Channels List */}
      <div className='rounded-lg border bg-card shadow-sm'>
        <div className='bg-gradient-to-r from-purple-50 to-pink-50 dark:from-gray-800 dark:to-gray-700 px-6 py-4 border-b'>
          <h2 className='text-xl font-semibold text-gray-800 dark:text-gray-100'>Filter Channels</h2>
          <p className='text-sm text-gray-600 dark:text-gray-400 mt-1'>Filter and view channel performance metrics</p>
        </div>
        <div className='p-6'>
          <div className='flex flex-wrap items-start gap-4'>
            {chanelDates.map((item, ind) => {
              const minDate = [null, dateFilters.startDate];
              const max = dateFilters.endDate ? dateFilters.endDate : new Date();
              const maxDate = [max, new Date()];
              const values = [dateFilters.startDate, dateFilters.endDate];
              return (
                <div key={ind} className='flex-1 min-w-[160px]'>
                  <Datepicker
                    title={item.title}
                    name={item.name}
                    value={values[ind]}
                    setValue={(date, value) => dateHandler(date, value)}
                    errorMsg={ind === 0 ? dateErr : dateToErr}
                    minDate={minDate[ind]}
                    maxDate={maxDate[ind]}
                    ids={item.ids}
                    info={item.info}
                  />
                </div>
              );
            })}
            <div className='flex gap-2 mt-7'>
              <Button onClick={(e) => onSearchClick(e)} id="searchAffiliate">
                Search
              </Button>
              <Button onClick={(e) => onResetClick(e)} variant="outline" id="affiliateReset">
                Reset
              </Button>
            </div>
          </div>
        </div>
        {hasSearched && (<div className='border-t'>
          <div className='p-6 space-y-4'>
          {Array.isArray(channelList) && channelList.length > 0 && (
            <Vpagination
              data={channelList}
              totalRecords={props.channelList?.totalRecords}
              paginationFirstValue={props.page}
              paginationSecondValue={props.items}
              setPaginationFirstValue={setChannel_page}
              setPaginationSecondValue={setChannelItems}
              recordsShow={props.visibleRecords}
              setRecordsShow={setChannelRecords}
              isVisible={props.isToShow}
              setIsVisible={setChanelVisible}
              csvData={tableData}
              exportPDF={exportPDF}
              payloadData={userId}
              callApi={callApi}
              csvFileName={"Channel Report"}
            />
          )}
          <div className='relative rounded-md border overflow-hidden'>
            <TableToolbar
              columns={channelAllColumns}
              onToggle={channelToggleVisibility}
              onReorder={channelReorder}
              onReset={channelResetToDefault}
            />
            <div className='overflow-x-auto'>
              <Table scrollKey="channelsChannel">
                <TableHeader>
                  <TableRow className='bg-muted/50'>
                    {channelVisibleIndices.map((origIdx) => (
                      <TableHead key={origIdx} className='text-center whitespace-nowrap px-4 py-3 font-semibold'>
                        <div className='flex items-center justify-center gap-1.5'>
                          <span>{headers[origIdx]}</span>
                          <Tooltips info={channelInfo[origIdx]} />
                        </div>
                      </TableHead>
                    ))}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {Array.isArray(channelList) && channelList.length > 0 ? (
                    channelList.map((item, index) => (
                      <TableRow key={index} className='hover:bg-muted/30 transition-colors'>
                        {channelVisibleIndices.map((origIdx) => (
                          <TableCell key={origIdx} className={cn('text-center px-4', (origIdx === 3 || origIdx === 4) && 'whitespace-nowrap', origIdx === 1 && 'font-medium')}>
                            {channelRowAccessors[origIdx](item)}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                  ) : (
                    <NoDataFound colspan={channelVisibleIndices.length} />
                  )}
                </TableBody>
              </Table>
            </div>
          </div>
          </div>
        </div>)}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    channelList: state.affiliateSlice.channelList,
    page: state.affiliateSlice.channel_page,
    items: state.affiliateSlice.channelItems,
    visibleRecords: state.affiliateSlice.channelRecords,
    isToShow: state.affiliateSlice.chanelVisible,
    docsData_channel: state.affiliateSlice.docsData_channel,
    channelField: state.affiliateSlice.channelField,
  };
};

export default connect(mapStateToProps)(Channel);